import type { EmptyTrashBatchResponse } from '@email/shared';

export interface EmptyTrashProgress {
  deletedMessageCount: number;
  remainingMessageCount: number;
}

export interface EmptyTrashResult extends EmptyTrashProgress {
  complete: boolean;
}

export const MAX_EMPTY_TRASH_BATCHES = 100;

export async function drainEmptyTrashBatches(
  requestBatch: () => Promise<EmptyTrashBatchResponse>,
  onProgress?: (progress: EmptyTrashProgress) => void,
  maxBatches = MAX_EMPTY_TRASH_BATCHES,
): Promise<EmptyTrashResult> {
  let deletedMessageCount = 0;
  let remainingMessageCount = 0;
  for (let batch = 0; batch < maxBatches; batch += 1) {
    const response = await requestBatch();
    deletedMessageCount += response.deletedMessageCount;
    remainingMessageCount = response.remainingMessageCount;
    onProgress?.({ deletedMessageCount, remainingMessageCount });
    if (remainingMessageCount === 0) {
      return { deletedMessageCount, remainingMessageCount, complete: true };
    }
    if (response.deletedMessageCount === 0) break;
  }
  return { deletedMessageCount, remainingMessageCount, complete: false };
}
